import { CircularLoader } from './CircularLoader';

/** Centered blue spinner used as the standard full-page loading indicator for pages/sections. */
const PageLoader = () => (
  <div className="h-full flex items-center justify-center">
    <CircularLoader className="size-8" />
  </div>
);

export { PageLoader };
